import { Box, List, ListItem, Stack, Typography } from '@mui/material';
import section9_bg from 'assets/img/ECommerce/section9_bg.png';
import section9_icon from 'assets/img/ECommerce/section9_icon.png';
import section9_image from 'assets/img/ECommerce/section9_image.png';
import AnimatedButton from 'components/common/AnimatedButton';
import React, { JSX } from 'react';
import theme from 'theme/index';
import { E_COMMERCE_STYLES } from './config';
import { paths } from 'routes/routes/paths';
import { Link } from 'react-router-dom';

export default function Section9(): JSX.Element {
  return (
    <Box
      sx={{
        pt: 10,
        pb: 6,
        color: '#cfe0ff',
        background: 'linear-gradient(to bottom, #051F65, #020C26)',
      }}
    >
      <Box maxWidth={E_COMMERCE_STYLES.container.maxWidth} mx={E_COMMERCE_STYLES.container.mx}>
        <Stack px={2} spacing={2}>
          <Typography
            variant="body1"
            letterSpacing={'2px'}
            lineHeight={'44px'}
            fontSize={38}
            color={theme.palette.darkBlue.light}
            className="font-helvetica-thin"
          >
            Mobile‑First <br /> Experience!
          </Typography>

          <Typography variant="body2" className="font-helvetica-light" color="white">
            We prioritize mobile — because that’s where your customers are. From Flutter-powered
            apps to responsive web interfaces, we ensure smooth, intuitive shopping across every
            device.
          </Typography>

          <Typography variant="body1" className="font-helvetica-bold" color="#6A91FD">
            Why it matters:
          </Typography>

          <List sx={{ listStyle: 'disc', pl: 3, pt: 0, width: '90%' }}>
            <ListItem sx={{ display: 'list-item', p: 0, mb: 1 }}>
              <Typography variant="body2" className="font-helvetica-light" color="white">
                Designed for mobile-dominant GCC markets
              </Typography>
            </ListItem>
            <ListItem sx={{ display: 'list-item', p: 0, mb: 1 }}>
              <Typography variant="body2" className="font-helvetica-light" color="white">
                Seamless performance across smartphones, tablets, and desktops
              </Typography>
            </ListItem>
            <ListItem sx={{ display: 'list-item', p: 0 }}>
              <Typography variant="body2" className="font-helvetica-light" color="white">
                Native app feel, faster loading, and higher engagement
              </Typography>
            </ListItem>
          </List>
        </Stack>
        <Stack px={1}>
          <Box
            component="img"
            src={section9_image}
            alt="hero"
            sx={{
              width: '100%',
              borderRadius: 2,
              position: 'relative',
              mt: 10,
            }}
          />

          <Box sx={{ p: 3, pt: 5 }}>
            <Typography
              mb={1}
              variant="h4"
              fontSize={26}
              className="font-helvetica-thin"
              color="#6A91FD"
            >
              Enterprise‑Grade Scaling <br /> with Microservices
            </Typography>
            <Typography variant="body2" className="font-helvetica-light" color="white">
              Built for reliability, performance, and long-term scale.Our modular architecture
              ensures each part of your system can evolve without disrupting the rest.
            </Typography>
            <List sx={{ listStyle: 'disc', pl: 3 }}>
              <ListItem sx={{ display: 'list-item', p: 0, mb: 1 }}>
                <Typography variant="body2" className="font-helvetica-light" color="white">
                  Independently scalable backend components
                </Typography>
              </ListItem>
              <ListItem sx={{ display: 'list-item', p: 0, mb: 1 }}>
                <Typography variant="body2" className="font-helvetica-light" color="white">
                  Faster updates and reduced downtime
                </Typography>
              </ListItem>
              <ListItem sx={{ display: 'list-item', p: 0 }}>
                <Typography
                  variant="body2"
                  className="font-helvetica-light"
                  color="white"
                // color="#cfe0ff"
                >
                  Reliable performance during peak loads and growth phases
                </Typography>
              </ListItem>
            </List>
          </Box>
        </Stack>
      </Box>
      <Stack position={'relative'}>
        <Box
          component="img"
          src={section9_bg}
          alt="hero"
          sx={{
            width: '100%',
            borderRadius: 2,
          }}
        />

        <Box
          sx={{ p: 3, pt: 5, marginTop: '-220px' }}
          maxWidth={E_COMMERCE_STYLES.container.maxWidth}
          mx={E_COMMERCE_STYLES.container.mx}
        >
          <Box
            component="img"
            src={section9_icon}
            alt="hero"
            sx={{
              width: '70px',
              height: '74px',
              mb: '40px',
            }}
          />

          <Typography
            mb={1}
            variant="h4"
            fontSize={26}
            className="font-helvetica-thin"
            color="#1F5BFF"
          >
            Enterprise-Grade <br /> Security, Built-In
          </Typography>
          <Typography variant="body2" className="font-helvetica-light" color="white">
            Trust is non-negotiable. Our platforms are built with security at their core — giving
            peace of mind to both you and your customers.
          </Typography>
          <List sx={{ listStyle: 'disc', pl: 3 }}>
            <ListItem sx={{ display: 'list-item', p: 0, mb: 1 }}>
              <Typography variant="body2" className="font-helvetica-light" color="white">
                End-to-end data encryption
              </Typography>
            </ListItem>
            <ListItem sx={{ display: 'list-item', p: 0, mb: 1 }}>
              <Typography variant="body2" className="font-helvetica-light" color="white">
                Role-based access controls
              </Typography>
            </ListItem>
            <ListItem sx={{ display: 'list-item', p: 0 }}>
              <Typography
                variant="body2"
                className="font-helvetica-light"
                color="white"
              // color="#cfe0ff"
              >
                Secure, tokenized APIs
              </Typography>
            </ListItem>
          </List>

          <Link to={paths.public.schedule}>
            <AnimatedButton
              label="Book a Security Consultation"
              sx={{ mt: 1.5, textAlign: 'start' }}
            />
          </Link>
          <Typography mt={1} maxWidth={300} variant="body2" color="#5775C7" className="font-serif">
            Just a{' '}
            <b>
              <u> 60-minute deep dive</u>{' '}
            </b>{' '}
            into what’s holding you back — and how to fix it.
          </Typography>
        </Box>
      </Stack>
    </Box>
  );
}
